{
  "id": "campaign-002",
  "name": "Clover Yard",
  "seed": "campaign:2",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": ["......", "......", "......", "..#...", "......", ".....S"],
  "critters": [],
  "pickups": [
    {
      "kind": "coin",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 4
    }
  ],
  "generatorVersion": 3,
  "level": 2,
  "biome": "backyard",
  "par": {
    "reel": 1020,
    "push": 884,
    "selfPropelled": 816,
    "tractor": 780,
    "zeroTurn": 578,
    "fairway": 308
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 3
    }
  }
}
